import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChevronButton = styled(IconButton)(({ theme }) => ({
  backdropFilter: `blur(${theme.spacing(2)})`,
  backgroundColor: `${theme.palette.dsSurface.v200}80`,
  border: `1px solid ${theme.palette.dsBase.v200}10`,
  width: theme.spacing(6),
  height: theme.spacing(6),
  padding: 0,
  transition: "border-color 0.2s ease-in-out, background 0.2s ease-in-out",
  "& .MuiSvgIcon-root": {
    fontSize: theme.spacing(4),
    color: theme.palette.dsBase.v200,
  },
  "&.Mui-disabled": {
    backdropFilter: `blur(${theme.spacing(2)})`,
    backgroundColor: `${theme.palette.dsSurface.v200}80`,
    border: `1px solid ${theme.palette.dsBase.v200}10`,
  },
  "&.Mui-disabled .MuiSvgIcon-root": {
    color: theme.palette.dsNeutral.v300,
  },
}));

export const ScrollContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  overflowX: "scroll",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  width: "auto",
  maxWidth: theme.spacing(90),
  flexShrink: 0,
  scrollBehavior: "smooth",
}));
